import { render, staticRenderFns } from "./ReserveKeyword.vue?vue&type=template&id=10bb0309&scoped=true"
import script from "./ReserveKeyword.vue?vue&type=script&lang=js"
export * from "./ReserveKeyword.vue?vue&type=script&lang=js"
import style0 from "./ReserveKeyword.vue?vue&type=style&index=0&id=10bb0309&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bb0309",
  null
  
)

export default component.exports